
  export default theme => ({
  
  bubbleInput: {
    width: 400
  },
  formLabel: {
    marginTop: 20,
    marginBottom: 3
  },
  tabInnerContent: {
    padding: theme.spacing(3),
    paddingBottom: 120,
  },
  levelContainer: {
    marginTop: 5
  },
  addButton:{
    height: 30, 
    width: 30, 
    marginLeft: 5, 
    opacity: .3,
    "&:hover":{
      opacity: 1
    }
  },
  contentTitle:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.background.light}`
  },
  tabContentActions: {
    width: "100%",
    position: "absolute",
    bottom: 0,
    left: 0,
    borderTop: `1px solid ${theme.palette.background.light}`,
    padding: theme.spacing(3)
  },
  bubblesWrapper: {
    margin: "15px 10px 10px 0",
    boxShadow: "0 2px 7px -2px #dfe0ec, 0 2px 2px -2px #010315",
    borderTop: `3px solid ${theme.palette.primary.main}`, 
    padding: theme.spacing(2),
    position: "relative",
    borderRadius: 3
  },
  bubblesEnvironment: {
    position: "absolute",
    top:-14,
    left: 10,
    padding: 5,
    color: theme.palette.primary.main,
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: .3,
    background: "#fff",
  },
  filterButton: {
    marginRight: 10
  },
  childBubble: {
    background: theme.palette.background.light,
    color: theme.palette.primary.main,
    border: "2px solid #e2eaf1",
    "&:hover":{
      background: theme.palette.background.light
    }
  },
  parentBubble: {
    background: theme.palette.background.light,
    color: theme.palette.primary.main,
    border: "2px solid #e2eaf1",
    "&:hover": {
      background: theme.palette.background.light
    }
  },
  row: {
    "&>div":{
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap"
    }
  }

})